import { createAction, props } from '@ngrx/store';

export const openBotflowPlayback = createAction(
  '[BotflowPlayback] Open Botflow Playback',
  props<{ customerId: string; productSavingsId: string }>()
);

export const openBotflowPlaybackSuccess = createAction(
  '[BotflowPlayback] Open Botflow Playback Success',
  props<{ response: string }>()
);

export const openBotflowPlaybackFailure = createAction(
  '[BotflowPlayback] Open Botflow Playback Failure',
  props<{ error: Error | any }>()
);
